export default "__VITE_ASSET__MEUEFp6i__"